import script from "./DeviceSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceSetting.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceSetting.vue?vue&type=style&index=0&id=97b99338&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97b99338"]])

export default __exports__